import React from 'react';
import { GetServerSideProps } from 'next';
import {
  getLocaleProps, WithLocale, WithAuthentication, getAuthenticationProps,
  OnFirePage, LoginOrErrorOrPage, AuthenticationProps, LocaleProps, PageWrapper
} from '@components/.';

interface PageProps {
  errorMsg?: string;
  notLogged?: boolean;
}

export const getServerSideProps: GetServerSideProps = async context => {
  let pageProps: PageProps;
  const locale = context.params.lang as string;
  const localeProps = await getLocaleProps(locale);
  const authenticationProps = await getAuthenticationProps(context);

  if (authenticationProps.currentUser === null) {
    pageProps = { notLogged: true }
  }
  else {
    pageProps = {}
  }

  return {
    props: {
      ...pageProps,
      ...authenticationProps,
      ...localeProps
    }
  }
}

const Page: React.FC<PageProps> = props => {
  return (
    <PageWrapper>
      <LoginOrErrorOrPage
        errorMsg={props.errorMsg}
        notLogged={props.notLogged}
      >
        <OnFirePage />
      </LoginOrErrorOrPage>
    </PageWrapper>
  );
}

const CompletePage: React.FC<PageProps & LocaleProps & AuthenticationProps> = props => {
  return (
    <WithLocale {...props}>
      <WithAuthentication {...props}>
        <Page {...props} />
      </WithAuthentication>
    </WithLocale>
  );
}

export default CompletePage;
